import React from 'react';

export default function ContabilizzaDetail({ selectedItem }) {
  return (
    <div className="container">
      <div className="row mb-4">
        <div className="col-12">
          <div className="card bg-light">
            <div className="card-body">
              <h6 className="card-subtitle mb-2 text-muted">Dettagli contabilizzazione</h6>
              <p className="mb-1"><strong>Corsista:</strong> {selectedItem?.corsista?.nome} {selectedItem?.corsista?.cognome}</p>
              <p className="mb-1"><strong>Partner:</strong> {selectedItem?.partner?.nome} {selectedItem?.partner?.cognome}</p>
              <p className="mb-1"><strong>Corso:</strong> {selectedItem?.denominazione_corso}</p>
              <p className="mb-1">
                <strong>Date corso:</strong> {new Date(selectedItem?.data_inizio).toLocaleDateString('it-IT')} - {new Date(selectedItem?.data_fine).toLocaleDateString('it-IT')}
              </p>
              <hr className="my-3" />
              <p className="mb-1">
                <strong>Sconto corsista:</strong>{' '}
                {selectedItem?.sconto ? `€ ${selectedItem.sconto}` : '-'}
              </p>
              <p className="mb-1">
                <strong>Provvigione partner:</strong>{' '}
                {selectedItem?.provvigione_partner ? `€ ${selectedItem.provvigione_partner}` : '-'}
              </p>
              <p className="mb-1">
                <strong>Numero fattura:</strong>{' '}
                {selectedItem?.numero_fattura || '-'}
              </p>
              <p className="mb-1">
                <strong>Data fattura:</strong>{' '}
                {selectedItem?.data_fattura ? new Date(selectedItem.data_fattura).toLocaleDateString('it-IT') : '-'}
              </p>
              <p className="mb-1">
                <strong>Note:</strong>{' '}
                {selectedItem?.note || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}